import React from 'react';

interface BottomNavProps {
    active: string;
    navigate: (page: string) => void;
    onDrawer: () => void;
    onGoLive: () => void;
}

export const BottomNav: React.FC<BottomNavProps> = ({ active, navigate, onDrawer, onGoLive }) => {
    const tabs = [
        { id: 'streams', icon: '⊞', label: 'Ana Sayfa' },
        { id: 'discover', icon: '◎', label: 'Keşfet' },
        { id: 'golive', icon: null, label: '' },
        { id: 'messages', icon: '✉', label: 'Mesajlar', badge: 3 },
        { id: 'profile', icon: '👤', label: 'Profil' },
    ];

    return (
        <div style={{
            position: 'absolute', bottom: 0, left: 0, right: 0,
            height: 74, display: 'flex', alignItems: 'center', justifyContent: 'space-around',
            background: 'rgba(9,9,14,0.97)', backdropFilter: 'blur(24px)',
            borderTop: '1px solid var(--border)', paddingBottom: 8, zIndex: 20
        }}>
            {tabs.map(tab =>
                tab.id === 'golive' ? (
                    <button key="live" onClick={onGoLive}
                        style={{
                            width: 52, height: 52, borderRadius: 18, border: 'none', cursor: 'pointer',
                            background: 'linear-gradient(135deg,var(--coral),var(--orange))',
                            fontSize: 22, display: 'flex', alignItems: 'center', justifyContent: 'center',
                            boxShadow: '0 6px 20px rgba(255,92,92,.45)', transition: 'transform .2s'
                        }}
                        onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1) translateY(-2px)'}
                        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                    >🎬</button>
                ) : (
                    <button key={tab.id} onClick={() => navigate(tab.id)}
                        style={{
                            background: 'none', border: 'none', cursor: 'pointer',
                            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2,
                            position: 'relative', padding: '4px 10px', minWidth: 44
                        }}>
                        {tab.badge && active !== tab.id ? (
                            <div style={{
                                position: 'absolute', top: -1, right: 4,
                                background: 'var(--coral)', borderRadius: '50%',
                                width: 15, height: 15, display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: 8, fontWeight: 700, color: '#fff', border: '2px solid #09090e',
                                animation: 'badgePop .3s ease'
                            }}>
                                {tab.badge}
                            </div>
                        ) : null}
                        <span style={{
                            fontSize: 19,
                            opacity: active === tab.id ? 1 : 0.45,
                            filter: active === tab.id ? 'drop-shadow(0 0 7px rgba(255,92,92,.7))' : 'none',
                            transition: 'all .25s',
                            transform: active === tab.id ? 'scale(1.1)' : 'scale(1)',
                        }}>{tab.icon}</span>
                        <span style={{
                            fontSize: 8.5, fontFamily: 'DM Sans', letterSpacing: '.04em',
                            color: active === tab.id ? 'var(--coral)' : 'var(--muted)',
                            fontWeight: active === tab.id ? 600 : 400, transition: 'color .2s'
                        }}>
                            {tab.label}
                        </span>
                    </button>
                )
            )}
        </div>
    );
};
